/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OrganAtRisk from './organ-at-risk';
import OrganAtRiskDetail from './organ-at-risk-detail';
import OrganAtRiskUpdate from './organ-at-risk-update';
import OrganAtRiskDeleteDialog from './organ-at-risk-delete-dialog';

const OrganAtRiskRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OrganAtRisk />} />
    <Route path="new" element={<OrganAtRiskUpdate />} />
    <Route path=":id">
      <Route index element={<OrganAtRiskDetail />} />
      <Route path="edit" element={<OrganAtRiskUpdate />} />
      <Route path="delete" element={<OrganAtRiskDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OrganAtRiskRoutes;
